/**
 * An opinionated, custom hook that fetches a project's flags.
 *
 * Every caller shares the same query key, so React Query dedupes concurrent
 * callers into a single request. React Admin's `useRefresh`, which the
 * `useMutation` hook calls after a successful mutation, invalidates the query
 * so that all callers pick up the new flags.
 */

import { Identifier, useDataProvider } from "react-admin";
import { useQuery } from "react-query";

import { CustomDataProvider, ProjectFlagResponse, Region } from "../types";

function useProjectFlags(region: Region, projectId: Identifier) {
  const dataProvider = useDataProvider<CustomDataProvider>();

  return useQuery<{ data: ProjectFlagResponse[] }>(
    ["getProjectFlags", { id: projectId, region }],
    () => dataProvider.getProjectFlags(region, projectId),
  );
}

export default useProjectFlags;
